// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"724":"a4fe211c","941":"af625773"}[chunkId] + ".chunk.css");